export class ServiceAddon {
    public id: number;
	public uuid: string;
	public name: string;
	public name_ar: string;
	public price: number;
	
	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);
		}
	}
}
